Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLeafSmall2Animation = exports.useLeafSmall1Animation = exports.useLeafBig2Animation = exports.useLeafBig1Animation = exports.useCloudWhiteAnimation = exports.useCloudPurpleAnimation = void 0;
var _react = require("react");
var _reactNative = require("react-native-web");
var _styles = require("./styles");
var _utils = require("../../utils");
var useCloudWhiteAnimation = exports.useCloudWhiteAnimation = function useCloudWhiteAnimation() {
  var opacity = (0, _react.useRef)(new _reactNative.Animated.Value(0)).current;
  var animation = _reactNative.Animated.timing(opacity, {
    useNativeDriver: _utils.useNativeDriver,
    toValue: 1,
    duration: 750
  });
  var styles = {
    opacity: opacity
  };
  return {
    styles: styles,
    animation: animation
  };
};
var useCloudPurpleAnimation = exports.useCloudPurpleAnimation = function useCloudPurpleAnimation() {
  var scale = (0, _react.useRef)(new _reactNative.Animated.Value(0)).current;
  var animation = _reactNative.Animated.timing(scale, {
    useNativeDriver: _utils.useNativeDriver,
    toValue: 1,
    duration: 1000
  });
  var styles = {
    transform: [{
      scale: scale
    }]
  };
  return {
    styles: styles,
    animation: animation
  };
};
var useLeafSmall1Animation = exports.useLeafSmall1Animation = function useLeafSmall1Animation() {
  var _StyleSheet$flatten$h;
  var isFixedSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var _useStyles = (0, _styles.useStyles)(isFixedSize),
    componentStyles = _useStyles.styles;
  var duration = 1000;
  var opacity = (0, _react.useRef)(new _reactNative.Animated.Value(0)).current;
  var _rotate = (0, _react.useRef)(new _reactNative.Animated.Value(0)).current;
  var rotate = _rotate.interpolate({
    inputRange: [0, 1],
    outputRange: ['45deg', '0deg']
  });
  var _height = parseInt(((_StyleSheet$flatten$h = _reactNative.StyleSheet.flatten(componentStyles.leafSmall1).height) != null ? _StyleSheet$flatten$h : 0).toString());
  var translate = (0, _react.useRef)(new _reactNative.Animated.Value(_height)).current;
  var animation = _reactNative.Animated.parallel([_reactNative.Animated.timing(opacity, {
    useNativeDriver: _utils.useNativeDriver,
    toValue: 1,
    duration: duration
  }), _reactNative.Animated.timing(_rotate, {
    useNativeDriver: _utils.useNativeDriver,
    toValue: 1,
    duration: duration
  }), _reactNative.Animated.timing(translate, {
    useNativeDriver: _utils.useNativeDriver,
    toValue: 0,
    duration: duration
  })]);
  var styles = {
    opacity: opacity,
    transform: [{
      rotate: rotate
    }, {
      translateX: translate
    }, {
      translateY: translate
    }]
  };
  return {
    styles: styles,
    animation: animation
  };
};
var useLeafBig1Animation = exports.useLeafBig1Animation = function useLeafBig1Animation() {
  var _StyleSheet$flatten$h2;
  var isFixedSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var _useStyles2 = (0, _styles.useStyles)(isFixedSize),
    componentStyles = _useStyles2.styles;
  var duration = 1000;
  var opacity = (0, _react.useRef)(new _reactNative.Animated.Value(0)).current;
  var _rotate = (0, _react.useRef)(new _reactNative.Animated.Value(0)).current;
  var rotate = _rotate.interpolate({
    inputRange: [0, 1],
    outputRange: ['45deg', '0deg']
  });
  var _height = parseInt(((_StyleSheet$flatten$h2 = _reactNative.StyleSheet.flatten(componentStyles.leafBig1).height) != null ? _StyleSheet$flatten$h2 : 0).toString());
  var translate = (0, _react.useRef)(new _reactNative.Animated.Value(_height)).current;
  var animation = _reactNative.Animated.parallel([_reactNative.Animated.timing(opacity, {
    useNativeDriver: _utils.useNativeDriver,
    toValue: 1,
    duration: duration
  }), _reactNative.Animated.timing(_rotate, {
    useNativeDriver: _utils.useNativeDriver,
    toValue: 1,
    duration: duration
  }), _reactNative.Animated.timing(translate, {
    useNativeDriver: _utils.useNativeDriver,
    toValue: 0,
    duration: duration
  })]);
  var styles = {
    opacity: opacity,
    transform: [{
      rotate: rotate
    }, {
      translateX: translate
    }, {
      translateY: translate
    }]
  };
  return {
    styles: styles,
    animation: animation
  };
};
var useLeafSmall2Animation = exports.useLeafSmall2Animation = function useLeafSmall2Animation() {
  var _StyleSheet$flatten$h3;
  var isFixedSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var _useStyles3 = (0, _styles.useStyles)(isFixedSize),
    componentStyles = _useStyles3.styles;
  var duration = 1000;
  var opacity = (0, _react.useRef)(new _reactNative.Animated.Value(0)).current;
  var _rotate = (0, _react.useRef)(new _reactNative.Animated.Value(0)).current;
  var rotate = _rotate.interpolate({
    inputRange: [0, 1],
    outputRange: ['90deg', '0deg']
  });
  var _height = parseInt(((_StyleSheet$flatten$h3 = _reactNative.StyleSheet.flatten(componentStyles.leafSmall2).height) != null ? _StyleSheet$flatten$h3 : 0).toString());
  var translate = (0, _react.useRef)(new _reactNative.Animated.Value(-_height)).current;
  var animation = _reactNative.Animated.parallel([_reactNative.Animated.timing(opacity, {
    useNativeDriver: _utils.useNativeDriver,
    toValue: 1,
    duration: duration
  }), _reactNative.Animated.timing(_rotate, {
    useNativeDriver: _utils.useNativeDriver,
    toValue: 1,
    duration: duration
  }), _reactNative.Animated.timing(translate, {
    useNativeDriver: _utils.useNativeDriver,
    toValue: 0,
    duration: duration
  })]);
  var styles = {
    opacity: opacity,
    transform: [{
      rotate: rotate
    }, {
      translateX: translate
    }, {
      translateY: translate
    }]
  };
  return {
    styles: styles,
    animation: animation
  };
};
var useLeafBig2Animation = exports.useLeafBig2Animation = function useLeafBig2Animation() {
  var _StyleSheet$flatten$h4;
  var isFixedSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var _useStyles4 = (0, _styles.useStyles)(isFixedSize),
    componentStyles = _useStyles4.styles;
  var duration = 1000;
  var opacity = (0, _react.useRef)(new _reactNative.Animated.Value(0)).current;
  var _rotate = (0, _react.useRef)(new _reactNative.Animated.Value(0)).current;
  var rotate = _rotate.interpolate({
    inputRange: [0, 1],
    outputRange: ['90deg', '0deg']
  });
  var _height = parseInt(((_StyleSheet$flatten$h4 = _reactNative.StyleSheet.flatten(componentStyles.leafBig2).height) != null ? _StyleSheet$flatten$h4 : 0).toString());
  var translate = (0, _react.useRef)(new _reactNative.Animated.Value(-_height)).current;
  var animation = _reactNative.Animated.parallel([_reactNative.Animated.timing(opacity, {
    useNativeDriver: _utils.useNativeDriver,
    toValue: 1,
    duration: duration
  }), _reactNative.Animated.timing(_rotate, {
    useNativeDriver: _utils.useNativeDriver,
    toValue: 1,
    duration: duration
  }), _reactNative.Animated.timing(translate, {
    useNativeDriver: _utils.useNativeDriver,
    toValue: 0,
    duration: duration
  })]);
  var styles = {
    opacity: opacity,
    transform: [{
      rotate: rotate
    }, {
      translateX: translate
    }, {
      translateY: translate
    }]
  };
  return {
    styles: styles,
    animation: animation
  };
};